/**
 * Admin Titles page component.
 *
 * Route: `/admin/titles`
 * Requires authentication: Yes (admin only)
 *
 * @module AdminTitlesPage
 */

import TitleManager from '@/components/admin/TitleManager';

export default function AdminTitlesPage() {
  return <TitleManager />;
}
